import React, { FC } from 'react';
import styles from './KSeparator.module.scss';

const KSeparator: FC = () => {
  return <div className={styles.KSeparator} />;
};

export default KSeparator;
